import { createSlice } from '@reduxjs/toolkit';
import * as thunks from './thunks';
import selectors from './selectors';
import adapter from './adapter';

const slice = createSlice({
  name: 'brand',
  initialState: adapter.getInitialState({
    loading: false,
    meta: {},
  }),
  extraReducers: (builder) => {
    builder
      .addCase(thunks.fetch.pending, (state, action) => {
        state.loading = true;
        adapter.removeAll(state);
      })
      .addCase(thunks.fetch.fulfilled, (state, action) => {
        const { show_all } = action.meta.arg;
        const brands = show_all ? action.payload : action.payload.brands;

        adapter.setAll(state, brands);
        state.meta = action.payload.meta;
        state.loading = false;
      })
      .addCase(thunks.fetch.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

const brand = {
  slice,
  thunks,
  selectors,
};
export default brand;
